{
  "level": "city2",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:city2",
    "objects": "AREAS.E3:city2.e3",
    "mesh": "TREES.E3:city2.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        415.0,
        712.5,
        100.0
      ],
      "bbox_max": [
        1317.5,
        1357.5,
        190.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        706.5,
        712.5,
        100.0
      ],
      "bbox_max": [
        806.5,
        1138.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        706.5,
        712.5,
        110.0
      ],
      "bbox_max": [
        766.5,
        1138.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        706.5,
        1133.0,
        120.0
      ],
      "bbox_max": [
        711.5,
        1138.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        415.0,
        849.0,
        157.0
      ],
      "bbox_max": [
        1317.5,
        1357.5,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        484.0,
        849.0,
        157.0
      ],
      "bbox_max": [
        1317.5,
        1315.5,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -157.0,
      "bbox_min": [
        484.0,
        1195.5,
        157.0
      ],
      "bbox_max": [
        489.0,
        1315.5,
        157.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -165.0,
      "bbox_min": [
        1312.5,
        849.0,
        165.0
      ],
      "bbox_max": [
        1317.5,
        854.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -174.0,
      "bbox_min": [
        415.0,
        887.0,
        172.0
      ],
      "bbox_max": [
        1317.5,
        1357.5,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -172.0,
      "bbox_min": [
        1312.5,
        887.0,
        172.0
      ],
      "bbox_max": [
        1317.5,
        892.0,
        172.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        415.0,
        1338.5,
        175.0
      ],
      "bbox_max": [
        475.0,
        1357.5,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        415.0,
        1352.5,
        190.0
      ],
      "bbox_max": [
        420.0,
        1357.5,
        190.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}